import { Molecule, wrap } from 'AppReact';
import { Text, Icon } from 'atoms';
import { SortArrowsSvg } from 'components/icons';
import { Mr1 } from 'wrappers';
import styled from 'styled-components';

const template = styled.div`
  display: flex;
  align-items: center;
  margin: 0px;
  font-weight: 500;
  max-width: 100px;
  width: 88px;
  font-size: 12px;
  color: #99A6B7;
  letter-spacing: 0.1px;
  word-break: break-word;
  cursor: pointer;
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Text, Mr1),
      name: 'Label',
      displayValue: ({ content }) => content.label
    },
    {
      component: Icon,
      name: 'SortArrows',
      renderIf: ({ content }) => !!content?.sortingField,
      displayValue: ({ sortOrder }) => SortArrowsSvg({ sortOrder, width: 4 }),
    },
  ]
})